/**
 * Chaves de query da vitrine.
 *
 * `searchAccess` é prefixo próprio e não entra na chave da busca: a chave do
 * Typesense é lida dentro da `queryFn` (via `ensureQueryData`), então
 * invalidá-la faz a busca seguinte reemitir sem repovoar o cache com uma
 * entrada por chave rotacionada.
 */
export const storefrontKeys = {
  all: ['storefront'] as const,
  searchAccess: () => [...storefrontKeys.all, 'search-access'] as const,
  taxonomy: () => [...storefrontKeys.all, 'taxonomy'] as const,
  /** Prefixo de TODAS as listagens (qualquer recorte/página). */
  searchAll: () => [...storefrontKeys.all, 'search'] as const,
  search: (
    q: string,
    filterBy: string,
    sortBy: string,
    page: number,
    perPage: number
  ) =>
    [...storefrontKeys.searchAll(), q, filterBy, sortBy, page, perPage] as const,
  /**
   * Sugestões do topo.
   *
   * Segmento próprio sob `searchAll` de propósito: a resposta vem sem facetas e
   * com outro `perPage`, então ela não é uma página da listagem e não deve
   * ocupar a mesma entrada — mas continua sendo busca, e a invalidação por
   * prefixo tem de alcançá-la.
   */
  autocomplete: (q: string) =>
    [...storefrontKeys.searchAll(), 'autocomplete', q] as const,
  /**
   * As quatro fotos do hero/modal da pronta entrega.
   *
   * Sob `searchAll` pelo mesmo motivo do autocomplete: é busca (a chave
   * escopada rotaciona junto), mas não é uma página da listagem.
   */
  readyDeliveryPreview: () =>
    [...storefrontKeys.searchAll(), 'ready-delivery-preview'] as const,
  /** Prefixo de TODA hidratação de disponibilidade. */
  availabilityAll: () => [...storefrontKeys.all, 'availability'] as const,
  availability: (idsDigest: string) =>
    [...storefrontKeys.availabilityAll(), idsDigest] as const,
  product: (productId: string) =>
    [...storefrontKeys.all, 'product', productId] as const,
  cart: () => [...storefrontKeys.all, 'cart'] as const,
  home: () => [...storefrontKeys.all, 'home'] as const,
  banners: () => [...storefrontKeys.all, 'banners'] as const,
  /** Uma página de campanha, por slug. */
  campaign: (slug: string) =>
    [...storefrontKeys.all, 'campaign', slug] as const,
  /** Prefixo de TODA leitura de pedido — listagem e detalhe. */
  ordersAll: () => [...storefrontKeys.all, 'orders'] as const,
  orders: () => [...storefrontKeys.ordersAll(), 'list'] as const,
  order: (orderId: string) => [...storefrontKeys.ordersAll(), orderId] as const,
};
